module.exports = __webpack_public_path__ + "img/btn_training_camp@2x.ee1cf684.png";